import React from 'react'

const ManageProperty = () => {
  return (
    <div>ManageProperty</div>
  )
}

export default ManageProperty